import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '45px',
    marginBottom: '15px'
  },
  headerColumn: {
    maxWidth: '45%'
  },
  headerSecondary: {
    height: '55px',
    marginBottom: '15px'
  },
  fareItem: {
    height: '524px'
  }
};

const SkeletonPackagesCarousel = (props) => {
  const [className, style] = useStyles(props);
  const { rowCant = 3 } = props;

  const { header, headerColumn, headerSecondary, fareItem } = styles;
  return (
    <Box
      className={`${className} ${SkeletonPackagesCarousel.componentName} fr-skeleton`}
      style={style}
    >
      <Row gutters>
        <Col className={`${SkeletonPackagesCarousel.componentName} header`} style={headerColumn}>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col className={`${SkeletonPackagesCarousel.componentName} headerSecondary`}>
          <Box className="fr-skeleton-element" style={headerSecondary} />
        </Col>
      </Row>
      <Row gutters>
        {Array(rowCant)
          .fill('')
          .map((i, index) => {
            return (
              <Col key={index} className={`${SkeletonPackagesCarousel.componentName} content`}>
                <Box
                  className={`${SkeletonPackagesCarousel.componentName} fr-skeleton-fare-item fr-skeleton-element`}
                  style={fareItem}
                />
              </Col>
            );
          })}
      </Row>
    </Box>
  );
};

SkeletonPackagesCarousel.componentName = 'SkeletonPackagesCarousel';

export default SkeletonPackagesCarousel;
